/* global toastr */
import { BaseAdminModelView } from '../model_view'
import { wrapView } from '../../smart_bps/lib/utils'
import { stateToProps } from '../../smart_bps/admin/base_view'

class MembershipsRefAdminModelView extends BaseAdminModelView {
  constructor(props) {
    super(props)
  }

  /** Удаляем поиск в верхней полосе действий **/
  renderTopPanelLeftItems() {
      return []
  }

  /** Запрещаем сохранять и удалять **/
  renderContentLeftAction() {
    return (
      <div className="card mb-3" key="actions">
        <div className="card-body p-2">
          <span className="btn btn-outline-primary waves-effect p-2 me-2" onClick={this.saveObject}>
            <span className="ti ti-xs ti-check me-1"></span>
            Сохранить
          </span>
        </div>
      </div>
    )
  }
}

export default wrapView(MembershipsRefAdminModelView, stateToProps)
